import React from 'react';
import { Link } from '@zola/zola-ui';

function SeatingTips() {
  return (
    <div id="confirm-action-modal">
      <div className="modal-header">
        <h3>4 Tips For Creating A Seating Chart</h3>
      </div>
      <div className="modal-body">
        <p>
          Making a seating chart for your wedding is a great way to help ensure guests feel comfortable on the big day. Not sure where to start? Here are a few tips, so you can get the most out of our seating chart tool.
        </p>
        <p style={{ textAlign: 'left' }}>
          <ol>
            <li>
              <strong>Start with the head table.</strong><br />
              Decide if you&apos;d like to sit at your own sweetheart table or a head table with your wedding party. Then drag and drop guests from your guest list to your table of choice. Or, tap any seat at the table, then search for a guest&apos;s name.
            </li>
            <li>
              <strong>Focus on family and close friends first.</strong><br />
              Once finished with your head table, move on to placing your loved ones. You can filter guests by their relationship to you two, then drag and drop entire parties from your guest list to any table. You can always place guests one at a time, too.
            </li>
            <li>
              <strong>Categorize guests by groups.</strong><br />
              Separate your guests into categories (think: family friends, high school friends, kids). It&apos;ll make it easier to figure out who could mesh well together at the same table.
            </li>
            <li>
              <strong>Think about who will get along best.</strong><br />
              As you map out where guests will sit, keep their relationships, personalities, and interests in mind (and skip the singles&apos; table altogether). You can always drag and drop guests&apos; names to rearrange seats at any table.
            </li>
          </ol>
        </p>

        <p>
          Have more questions about creating a seating chart?<br />
          Head on over to <Link inline href="https://www.zola.com/expert-advice/planning-101/reception/how-to-create-a-wedding-seating-chart" target="_blank" without rel="noopener noreferrer">this article</Link> for expert advice.
        </p>
      </div>
    </div>
  );
}
export default SeatingTips;



// WEBPACK FOOTER //
// ./src/components/manage/seatingchart/Modals/SeatingTips.jsx